import { POS_ROUTE } from "../../constants/constants"

export const RESERVATIONS_V2_ROUTE = POS_ROUTE + "/reservations-v2"

